import { buildIpfsGatewayUrl, IPFS_URI_SCHEMA, } from "@torus-network/torus-utils/ipfs";
import { z } from "zod";
import { AGENT_METADATA_SCHEMA } from "./agent_metadata/agent_metadata";
const CUSTOM_METADATA_SCHEMA = z.object({
    title: z.string().optional(),
    body: z.string().optional(),
});
export const APPLICATION_METADATA_SCHEMA = z.object({
    title: z.string(),
    body: z.string(),
    discord_id: z.string().optional(),
});
export async function processMetadata(zodSchema, url, entryId, kind) {
    const response = await fetch(url);
    const obj = await response.json();
    const validated = zodSchema.safeParse(obj);
    if (!validated.success) {
        const message = `Invalid metadata for ${kind} ${entryId} at ${url}`;
        return { Err: { message } };
    }
    return { Ok: validated.data };
}
export async function processProposalMetadata(url, entryId) {
    return await processMetadata(CUSTOM_METADATA_SCHEMA, url, entryId, "PROPOSAL");
}
export async function processApplicationMetadata(url, entryId) {
    return await processMetadata(APPLICATION_METADATA_SCHEMA, url, entryId, "AGENT_APPLICATION");
}
export async function processAgentMetadata(url, entryId) {
    return await processMetadata(AGENT_METADATA_SCHEMA, url, entryId, "AGENT  ");
}
export async function fetchCustomMetadata(kind, entryId, metadataField) {
    const r = IPFS_URI_SCHEMA.safeParse(metadataField);
    if (!r.success) {
        return appendErrorInfo(r.error.errors.map((e) => e.message).join("\n"), `for ${kind} ${entryId}`);
    }
    const cid = r.data;
    const url = buildIpfsGatewayUrl(cid);
    let metadata;
    if (kind === "proposal") {
        metadata = await processProposalMetadata(url, entryId);
    }
    else if (kind === "application") {
        metadata = await processApplicationMetadata(url, entryId);
    }
    else {
        metadata = await processAgentMetadata(url, entryId);
    }
    return metadata;
}
export function appendErrorInfo(err_msg, info, sep = " ") {
    const message = err_msg + sep + info;
    return { Err: { message } };
}
